var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader-wrapper"},[_c('BubbleSVG',{ref:"Bubble",staticClass:"bubble"}),_c('span',{ref:"Progress",staticClass:"percent"},[_vm._v(_vm._s(Math.round(_vm.progression)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }